import { connect } from 'react-redux';
import { createSelector } from 'reselect';
// eslint-disable-next-line import/no-cycle
import { selectMobileNumber } from '../../selectors';
import Component from './Component';

const mapStateToProps = createSelector(selectMobileNumber, (mobileNumber) => ({
  mobileNumber,
}));

export default connect(mapStateToProps, null)(Component);
